import axios from "axios";
import { API_URL, REDIRECT_URI } from "./constants";
import { msalInstance } from "..";
import { loginRequest } from "../authConfig";
import { getE2EAccessToken, isE2EModeEnabled } from "./runtimeMode";

const baseURL = REDIRECT_URI === "http://localhost:3000" ? "/" : API_URL;
// console.log("base url is", baseURL)
const axiosInstance = axios.create({ baseURL: baseURL });

axiosInstance.interceptors.request.use(async (config) => {
  if (isE2EModeEnabled()) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${getE2EAccessToken()}`;
    return config;
  }

  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error("No account!");
  }
  
  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });

  config.headers = config.headers ?? {};
  config.headers.Authorization = response.accessToken
    ? `Bearer ${response.accessToken}`
    : "";
  return config;
});

// Adding an interceptor to log requests after they are made
axiosInstance.interceptors.request.use(
  (config) => {
    console.log("Request made:", config.url);
    return config;
  },
  (error) => {
    console.error("Error in request interceptor:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  async (response) => response,
  async (error) => {
    switch (error.response?.status) {
      case 404:
        throw Error(error.response.data?.message);
      case 401:
        if (isE2EModeEnabled()) {
          throw error;
        }
        window.location.href = "/";
        break;
      default:
        throw error;
    }
  }
);

export default axiosInstance;
